'use client';

import React from 'react';
import { getUsercentricsScriptProps } from 'utils';
import Script from 'next/script';

type Props = {
  language: string;
};

/**
 * UsercentricsScript Component
 *
 * This component dynamically loads the Usercentrics script based on the provided language.
 * It utilizes the Next.js Script component with the "lazyOnload" strategy to optimize loading.
 *
 * The "lazyOnload" strategy ensures the script is loaded only after the browser's main thread is idle,
 * improving page performance. For more details on Next.js Script strategies, visit:
 * https://nextjs.org/docs/pages/api-reference/components/script#strategy
 *
 * Props:
 * - language: A string representing the language code to configure the Usercentrics script.
 */
export function UsercentricsScript({ language }: Props) {
  const { key, ...rest } = getUsercentricsScriptProps(language);

  return <Script key={key} {...rest} strategy="lazyOnload" />;
}
